export const popoverLocale = {
    closeLabel: 'Close',
};
//# sourceMappingURL=Popover.locale.mjs.mjs.map